import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { fundSetupI18nText } from '../pages/portfolio/funds/edit/i18n.ts';
import { renderMarkdown } from '~/functions/markdown';
import { useGetFundQuery, useUpdateKfwReportingMutation } from '~/types/types';
import { getLocale } from '~/functions/translate';
export default /*#__PURE__*/_defineComponent({
  __name: 'kfwVentures',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fundId: {
      type: Number,
      required: true
    },
    hideQuestionHeader: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useGetFundQuery = useGetFundQuery({
        id: props.fundId || ''
      }),
      fundResult = _useGetFundQuery.result;
    var _useUpdateKfwReportin = useUpdateKfwReportingMutation(),
      updateKfwReporting = _useUpdateKfwReportin.mutate,
      loading = _useUpdateKfwReportin.loading;
    var fund = computed(function () {
      var _fundResult$value;
      return (_fundResult$value = fundResult.value) === null || _fundResult$value === void 0 ? void 0 : _fundResult$value.getFund;
    });
    var minimumReportingLevelVentureIds = computed(function () {
      var _fund$value;
      return (fund === null || fund === void 0 ? void 0 : (_fund$value = fund.value) === null || _fund$value === void 0 ? void 0 : _fund$value.minimumReportingLevelVentureIds) || [];
    });
    var recommendedReportingLevelVentureIds = computed(function () {
      var _fund$value2;
      return (fund === null || fund === void 0 ? void 0 : (_fund$value2 = fund.value) === null || _fund$value2 === void 0 ? void 0 : _fund$value2.recommendedReportingLevelVentureIds) || [];
    });
    var fullReportingLevelVentureIds = computed(function () {
      var _fund$value3;
      return (fund === null || fund === void 0 ? void 0 : (_fund$value3 = fund.value) === null || _fund$value3 === void 0 ? void 0 : _fund$value3.fullReportingLevelVentureIds) || [];
    });
    var optionMapping = {
      minimum: 'minimumReportingLevelVentureIds',
      recommended: 'recommendedReportingLevelVentureIds',
      full: 'fullReportingLevelVentureIds'
    };
    var reportingLevels = {
      minimum: minimumReportingLevelVentureIds,
      recommended: recommendedReportingLevelVentureIds,
      full: fullReportingLevelVentureIds
    };
    var selectOption = function selectOption(item, selectedOption) {
      var _fund$value4;
      var allOptions = ['minimum', 'recommended', 'full'];
      var ventureId = item.id;
      var input = {
        id: (_fund$value4 = fund.value) === null || _fund$value4 === void 0 ? void 0 : _fund$value4.id
      };
      var updateInput = function updateInput(option, operation) {
        var currentArray = reportingLevels[option].value;
        if (operation === 'remove') {
          input[optionMapping[option]] = currentArray.filter(function (id) {
            return id !== ventureId;
          });
        } else if (operation === 'toggle') {
          input[optionMapping[option]] = currentArray.includes(ventureId) ? currentArray.filter(function (id) {
            return id !== ventureId;
          }) : [].concat(_toConsumableArray(currentArray), [ventureId]);
        }
      };
      allOptions.forEach(function (option) {
        if (option !== selectedOption) {
          updateInput(option, 'remove');
        }
      });
      updateInput(selectedOption, 'toggle');
      updateKfwReporting({
        input: input
      });
    };
    var getValueByPath = function getValueByPath(path, dict) {
      return path.split('.').reduce(function (acc, cur) {
        return acc === null || acc === void 0 ? void 0 : acc[cur];
      }, dict);
    };
    var locale = computed(function () {
      return getLocale();
    });
    var translate = function translate(key) {
      var _getValueByPath;
      var translation = (_getValueByPath = getValueByPath(key, fundSetupI18nText)) === null || _getValueByPath === void 0 ? void 0 : _getValueByPath[locale.value];
      if (!translation) {
        console.warn(key, fundSetupI18nText === null || fundSetupI18nText === void 0 ? void 0 : fundSetupI18nText.questions);
      }
      return translation;
    };
    return {
      __sfc: true,
      props: props,
      fundResult: fundResult,
      updateKfwReporting: updateKfwReporting,
      loading: loading,
      fund: fund,
      minimumReportingLevelVentureIds: minimumReportingLevelVentureIds,
      recommendedReportingLevelVentureIds: recommendedReportingLevelVentureIds,
      fullReportingLevelVentureIds: fullReportingLevelVentureIds,
      optionMapping: optionMapping,
      reportingLevels: reportingLevels,
      selectOption: selectOption,
      getValueByPath: getValueByPath,
      locale: locale,
      translate: translate,
      renderMarkdown: renderMarkdown
    };
  }
});